import HttpService from '../HttpService';
import { isAxiosError } from 'axios';
import { HttpStatus } from '../HttpService/HttpStatus';
import { IMenuItems, IAdminPermissions } from './types';

const getMenuItems = async (sessionToken?: string): Promise<IMenuItems[]> => {
  const { data: { menus } } = await HttpService.get<{menus: IMenuItems[]}>(
    'menu/get-menus',
    sessionToken,
  );
  return menus;
};

const updateAdminPermission = async (payload: IAdminPermissions, sessionToken?: string): Promise<any> => {
  try {
    const {
      data: user,
    } = await HttpService.patch<any>(
      'user/update-permissions',
      payload,
      sessionToken,
    );
    return user;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === HttpStatus.BAD_REQUEST) {
      throw error.response.data;
    }
    throw error;
  }
};
const PermissionService = {
  getMenuItems,
  updateAdminPermission
};

export default PermissionService;